import { z } from '../zod';

// Stripe Elements rejects a non-lowercase code outright (`IntegrationError:
// currency should be one of ... You specified: USD`), so normalize at the
// input boundary rather than trusting callers — including AI-generated payloads.
export const CurrencyCodeSchema = z.string().length(3).toLowerCase();
